// extracted by mini-css-extract-plugin
export var layout = "Layout-module--layout--21c63";